import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.'

@vsingleton()
export class AdminNoteRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'api.note.'

  getNotes(data) {
    return this.ziggyRoute('get_notes', data)
  }

  store() {
    return this.ziggyRoute('store')
  }

  update(noteId: number) {
    return this.ziggyRoute('update', noteId)
  }

  destroy(noteId: number) {
    return this.ziggyRoute('destroy', noteId)
  }
}